// JavaScript source code
/* eslint-disable */
import React from 'react';
import { StaticWithCodeCreate, StaticWithCodeEdit, StaticWithCodeShow, BaseListWithCurrent } from './Scaffolding';

export const CountryLabels = { pageTitle : "Countries" }

export const CountryList = props =>
    <BaseListWithCurrent {...props} />;

export const CountryEdit = props =>
    <StaticWithCodeEdit {...props} />;

export const CountryCreate = props =>
    <StaticWithCodeCreate {...props} />;

export const CountryShow = props =>
    <StaticWithCodeShow {...props} />;